module.exports = __webpack_public_path__ + "img/addBooking.91fa85b6.svg";